import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as NavConstants from 'constants/NavConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import {FilterKey, keyToEmptyFilter, SearchParams} from 'search/SearchConstants';
import {getAppliedSortsFromUserPreference} from 'search/SearchPreferences';

export function getDefaultJellyfishSearchParams(): SearchParams {
  return {
    filters: [
      {
        ...keyToEmptyFilter(FilterKey.TYPES),
        value: [ModelTypeConstants.JELLYFISH],
      },
    ],
    limit: getSelectedPageSize(),
    offset: 0,
    query: '',
    sorts: getAppliedSortsFromUserPreference(NavConstants.Section.JELLYFISH),
  };
}
